// @flow
import * as React from 'react';
import { rankWith, uiTypeIs, or, isBooleanControl } from '@jsonforms/core';

import Switch from '../components/Switch';
import useControlProps from '../util/useControlProps';

type Props = {
    action?: { text: string, onClick: () => void }
};

export const SwitchControl = ({ action, ...props }: Props): React.Node => {
    const {
        label,
        description,
        path,
        data,
        handleChange,
        visible,
        enabled,
        uischema: { options }
    } = useControlProps(props);

    const { isMaraOnlyField, style = 'card' } = options || {};

    return (
        visible && (
            <Switch
                value={data}
                onChange={value => handleChange(path, value)}
                disabled={!enabled}
                label={label}
                description={description}
                action={action}
                isMaraOnlyField={isMaraOnlyField}
                style={style}
            />
        )
    );
};

export default SwitchControl;

export const switchControlTester = rankWith(
    1,
    or(uiTypeIs('SwitchControl'), isBooleanControl)
);
